import { render, staticRenderFns } from "./ctHz.vue?vue&type=template&id=64d4f97d&scoped=true"
import script from "./ctHz.vue?vue&type=script&lang=js"
export * from "./ctHz.vue?vue&type=script&lang=js"
import style0 from "./ctHz.vue?vue&type=style&index=0&id=64d4f97d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4f97d",
  null
  
)

export default component.exports